import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 0 auto;
	padding: 32px 0 0;

	@media (max-width: 992px) {
		padding: 0;
	}
`;

export const Banner = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 24px;
`;

export const BannerContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	@media (max-width: 992px) {
		flex-grow: 1;
	}
`;

export const BannerTitle = styled.h2`
	margin: 0;
	width: 600px;
	font-size: 56px;
	line-height: 76px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		width: 100%;
		font-size: 32px;
		line-height: 44px;
	}
`;

export const BannerDescription = styled.p`
	margin: 0;
	font-size: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const ButtonWrapper = styled.div`
	display: flex;
`;

export const BannerImg = styled.div`
	width: 468px;
	height: 468px;
	min-width: 468px;
	min-height: 468px;

	img {
		width: 100%;
		height: 100%;
	}

	@media (max-width: 992px) {
		width: 335px;
		height: 335px;
		min-width: 335px;
		min-height: 335px;
		margin: 0 auto;
	}
`;

export const Instruction = styled.div`
	margin-top: 38px;
`;

export const InstructionTitle = styled.h3`
	font-size: 32px;
	line-height: 44px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 28px;
		line-height: 38px;
	}
`;

export const InstructionDescription = styled.p`
	margin-top: 12px;

	font-size: 20px;
	line-height: 27px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	span {
		color: ${({ theme }) => theme.colors.text.subtitle};
	}

	@media (max-width: 992px) {
		font-size: 18px;
		line-height: 25px;
	}
`;

export const InstructionRate = styled.p`
	font-weight: 600;
	font-size: 20px;
	line-height: 27px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-top: 8px;

	@media (max-width: 992px) {
		font-size: 18px;
		line-height: 25px;
	}
`;

export const InstructionStepsWrapper = styled.div`
	margin-top: 24px;
	position: relative;
`;

export const NextBtn = styled.button`
	position: absolute;
	right: 0;
	top: 50%;
	z-index: 100;
	width: 36px;
	height: 36px;
	transform: translateY(-50%);
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.control.light};

	display: none;
	justify-content: center;
	align-items: center;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.secondary};
		transform: rotate(180deg);
	}

	@media (max-width: 992px) {
		display: flex;
	}
`;

export const Faq = styled.div`
	margin: 38px 0 32px;
`;

export const FaqTitle = styled.h2`
	font-size: 32px;
	line-height: 44px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 24px;
`;

export const FaqDivider = styled.div`
	width: 100%;
	height: 1px;
	margin: 24px 0;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
`;
